import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { PageHeader, Result, Skeleton, Descriptions, Button } from 'antd';

import { Tag } from '@components/common';
import EditCoupon from './EditCoupon';

import CouponActions, { CouponsSelectors } from '@redux/CouponsRedux';

import { transformStripePrice } from '@services/transform';
import { formatDate } from '@utils/date';
import history from '@utils/history';
import { COLORS } from '@theme/styles';

function ViewCouponPage(props) {
  const {
    loadig,
    loadCoupon,
    couponData,
    match: { params, url }
  } = props;

  const { id: couponId } = params || {};

  const render404 = () => {
    return (
      <div className="coupons main-page">
        <PageHeader
          title="Coupon"
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="coupon main-content">
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
          />
        </div>
      </div>
    );
  };

  const renderCoupon = () => {
    const {
      title,
      usagePerUser,
      usageTotal,
      userID,
      notes,
      propertyID,
      serviceType,
      officeID,
      amount,
      percentage,
      status,
      createdAt,
      type: frequency,
      expireAt,
      office,
      aliases,
      days
    } = couponData;

    return (
      <div className="coupons main-page">
        <PageHeader
          title={title}
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        >
          <div
            className="content"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <div
              style={{
                width: '80%'
              }}
            >
              <Descriptions size="small" column={3}>
                <Descriptions.Item label="Created">
                  {formatDate(createdAt, true, 'LLL')}
                </Descriptions.Item>
                <Descriptions.Item label="Expire At">
                  {formatDate(expireAt, true, 'LLL')}
                </Descriptions.Item>
                <Descriptions.Item label="Status">
                  <Tag
                    content={status === 'active' ? 'Active' : 'InActive'}
                    color={COLORS[status]}
                  />
                </Descriptions.Item>
              </Descriptions>
            </div>
            <div className="extra">
              <Button
                key="1"
                type="primary"
                onClick={() => history.push(`${url}/edit`)}
              >
                Edit
              </Button>
            </div>
          </div>
        </PageHeader>

        <div className="main-content coupon">
          <Descriptions bordered column={1}>
            <Descriptions.Item label="Title">{title}</Descriptions.Item>
            <Descriptions.Item label="Aliasses">
              {aliases &&
                aliases
                  .map(item => (item.status === 'active' ? item.name : null))
                  .filter(item => !!item)
                  .join(', ')}
            </Descriptions.Item>
            <Descriptions.Item label="Office">
              {office && office.jsoin && office.join(', ')}
            </Descriptions.Item>
            <Descriptions.Item label="Discount">
              {percentage
                ? `${percentage}%`
                : `$${transformStripePrice(amount)}`}
            </Descriptions.Item>
            <Descriptions.Item label="Service Frequency">
              {frequency && frequency.join && frequency.join(', ')}
            </Descriptions.Item>
            <Descriptions.Item label="Service Types">
              {serviceType && serviceType.join && serviceType.join(', ')}
            </Descriptions.Item>
            <Descriptions.Item label="Total Uses">
              {usageTotal}
            </Descriptions.Item>
            <Descriptions.Item label="Uses per Client">
              {usagePerUser}
            </Descriptions.Item>
            <Descriptions.Item label="Days">
              {days && days.join && days.join(', ')}
            </Descriptions.Item>
            <Descriptions.Item label="Notes">{notes}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    );
  };

  if (!couponId) {
    return render404();
  }

  useEffect(() => {
    loadCoupon(couponId);
  }, [couponId]);

  if (loadig) {
    return (
      <div className="coupons main-page">
        <PageHeader
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="coupon main-content">
          <Skeleton />
        </div>
      </div>
    );
  }

  const { couponID: loadedId } = couponData || {};

  if (!loadedId) {
    return render404();
  }

  return (
    <Switch>
      <Route exact path={`${url}/`}>
        {renderCoupon()}
      </Route>
      <Route exact path={`${url}/edit`}>
        <EditCoupon />
      </Route>
    </Switch>
  );
}

ViewCouponPage.propTypes = {
  match: PropTypes.object,
  loadCoupon: PropTypes.func,
  loadig: PropTypes.bool,
  couponData: PropTypes.object
};

const mapStateToProps = state => ({
  loadig: CouponsSelectors.selectLoading(state),
  couponData: CouponsSelectors.selectCouponData(state)
});

const mapDispatchToProps = dispatch => ({
  loadCoupon: couponId => {
    dispatch(CouponActions.loadCouponRequest(couponId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewCouponPage);
